import { apiHelper } from '@/utils'
import { API } from '@/constants'

export const configurationService = {
  getAllConfigurations,
  getConfiguration,
  updateConfiguration,
}

const API_URL = API.BASE_URL + '/v1'

function buildParams(filter) {
  const params = {
    page: filter?.pageNumber,
    size: filter?.pageSize,
  }
  filter?.searchArray?.forEach((word, idx) => {
    if (word !== null && word !== '') params[`search_words[${idx}]`] = word
  })
  return params
}

export async function getAllConfigurations(filter) {
  return apiHelper(API_URL).get('/configurations', { params: buildParams(filter) })
}

export async function getConfiguration(key) {
  return apiHelper(API_URL).get(`/configurations/${key}`)
}

export async function updateConfiguration(key, value) {
  return apiHelper(API_URL).put(`/configurations/${key}`, { value })
}
